import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { MessageService, ConfirmationService } from 'primeng/api';
import { GifcardVirtualService } from 'src/app/services/gifcardVirtual.service';
import { GiftCardOrderSalesModel, GiftCardVirtualsModel } from "src/app/models/gifcardVirtual.model";
import { saveAs } from 'file-saver';
import { AuthService } from 'src/app/services/auth.service';
import { timer } from 'rxjs';
import { Subscription } from 'rxjs';
import { TraceService } from 'src/app/services/trace.service';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { FileUploadValidators } from '@iplab/ngx-file-upload';
import { FileService } from 'src/app/services/file.service';
import { GifcardFisicaService } from 'src/app/services/giftcardFisica.service';
import { GifcardTiendaService } from 'src/app/services/giftcardTienda.service';

@Component({
  selector: 'app-ordersales-tienda-step2-list',
  templateUrl: './ordersales-tienda-step2-list.component.html',
  styleUrls: ['./ordersales-tienda-step2-list.component.css']
})
export class OrdersalesTiendaStep2ListComponent implements OnInit, OnDestroy {

  constructor(private giftCardTiendaService: GifcardTiendaService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private traceService: TraceService,
    private fileService: FileService) { }

  private subscription: Subscription = new Subscription();
  totalOrderSales: number;
  dlgOrderSales: boolean;
  dlgEmailFails: boolean;
  dlgUpdateEmail: boolean;
  itemOrderSales;
  itemSendFails;
  selectOrderSales: GiftCardOrderSalesModel;
  datasourceTablaOrderSales: GiftCardOrderSalesModel[] = [];
  colsTablaOrderSales: any[];
  colsTablaEmailFails: any[];
  dataDetail: {};
  datasourceGiftCardVirtual: GiftCardVirtualsModel[] = [];
  loading: boolean = false;
  currentUser: string;
  dlgActivation: boolean = false;
  orderSalesFormGroup: FormGroup;
  fileLiquidacion = new FormControl(null, [FileUploadValidators.filesLimit(1)]);
  fileConstancia = new FormControl(null, [FileUploadValidators.filesLimit(1)]);
  fileGuia = new FormControl(null, [FileUploadValidators.filesLimit(1)]);

  disabledBtnObservation: boolean = true;
  disabledBtnDelete: boolean = false;

  ngOnInit() {
    this.currentUser = this.authService.getCurrentUser();
    this.createColumnsTablaGiftCardVirtual();
    //this.refreshData();
    this.populateTableOrderSales();
    this.createOrderSalesForm();
  }

  createOrderSalesForm() {
    this.orderSalesFormGroup = this.formBuilder.group({
      imgLiquidacion: this.fileLiquidacion,
      imgConstancia: this.fileConstancia,
      imgGuia: this.fileGuia,
      txtObservaciones: ['']
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  refreshData() {
    this.subscription.add(this.populateTableOrderSales());
    this.subscription.add(this.subscribeToData());
  }

  subscribeToData() {
    this.subscription.add(console.log("refreshdata"));
    this.subscription.add(
      timer(60000).subscribe(() => this.refreshData())
    );
  }

  createColumnsTablaGiftCardVirtual() {
    this.colsTablaOrderSales = [
      { field: 'NRO_ORDEN_COMPRA', header: 'Nro. Ord. Compra', width: '8%', align: 'center' },
      { field: 'NRORUC_CLIENTE', header: 'RUC', width: '7%', align: 'center' },
      { field: 'RAZSOC_CLIENTE', header: 'Razón Social', width: '25%', align: 'center' },
      { field: 'IMP_ORDEN_COMPRA', header: 'Importe', width: '8%', align: 'center' },
      { field: 'CREATIONUSER', header: 'Usuario Activador', width: '6%', align: 'center' },
      { field: 'CREATIONDATE', header: 'Fecha Activación', width: '6%', align: 'center' },
      { field: 'PERMANENCIA', header: 'Días Perman.', width: '6%', align: 'center' }
    ];
  }

  populateTableOrderSales() {
    this.loading = true;
    let params = {
      "p_flag_activo": 1,
      "p_isfacturado" : "N"
    }

    this.giftCardTiendaService.GetOrderSalesTiendaByStatus(params).subscribe(
      (response: GiftCardOrderSalesModel[]) => {
        this.datasourceTablaOrderSales = response;
        this.totalOrderSales = this.datasourceTablaOrderSales.length;
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al listar las ordenes de compra.' });
      }
    )
  }

  onShowConfirmFacturacion() {
    this.confirmationService.confirm({
      message: '¿Está seguro de cerrar la facturación de la orden de compra?',
      accept: () => {
        this.saveObservacion();
        this.disabledBtnObservation = true;
      }
    });
  }

  saveObservacion() {
    this.loading = true;
    this.createOrderSalesTrace('FACTURADO');
    this.updateOrderSalesTiendaFacturado();
    this.dlgOrderSales = false;
  }

  saveFileLiquidacion() {
    if (this.fileLiquidacion.value && !this.itemOrderSales.IMG_LIQUIDACION) {
      this.updateImageLiquidacion();
      this.validateUploadFile();
    }
    else {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Debe seleccionar el archivo liquidación' });
    }
  }

  validateUploadFile(){
    if ((this.fileLiquidacion.value || this.itemOrderSales.IMG_LIQUIDACION)){
        this.disabledBtnObservation = false;
        this.observation.enable();
      }
  }

  createOrderSalesTrace(status: string) {
    let params = {
      "p_id_order_gift_card": this.itemOrderSales.ID_ORDER_SALES,
      "p_id_modelo_gift_card": this.itemOrderSales.ID_MODELO_GIFT_CARD,
      "p_id_cliente_gift_card": this.itemOrderSales.ID_CLIENTE,
      "p_id_contact_gift_card": this.itemOrderSales.ID_CONTACT,
      "p_type_order_sales": this.giftCardTiendaService.TYPE_ORDER_SALES_TIENDA,
      "p_action": status,
      "p_observation": this.observation.value ? this.observation.value : 'Facturado correctamente.',
      "p_creationuser": this.currentUser
    };
    this.traceService.CreateGiftCardOrderSalesTrace(params).subscribe(
      (response) => {
        this.loading = false;
        this.populateTableOrderSales();
        this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Trace registrado correctamente.' });
      },
      (error) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al crear el trace de la orden de compra' });
      }
    )
  }

  deleteFileLiquidacion(id_file: number) {
    this.loading = true;
    this.itemOrderSales.IMG_LIQUIDACION = "";
    this.updateOrderSalesFileStatus(id_file);
  }

  deleteFileConstancia(id_file: number) {
    this.loading = true;
    this.itemOrderSales.IMG_CONSTANCIA = "";
    this.updateOrderSalesFileStatus(id_file);
  }

  deleteFileGuia(id_file: number) {
    this.loading = true;
    this.itemOrderSales.IMG_GUIA = "";
    this.updateOrderSalesFileStatus(id_file);
  }

  updateOrderSalesFileStatus(id_file: number) {
    let params = {
      "p_id_file": id_file,
      "p_flg_activo": 0
    };
    this.fileService.UpdateOrderSalesStatusFile(params).subscribe(
      (response) => {
        this.loading = false;
        this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Archivo eliminado correctamente.' });
      },
      (error) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al crear el trace de la orden de compra' });
      }
    )
  }

  updateOrderSalesTiendaFacturado() {
    let params = {
      "p_id_order_gift_card": this.itemOrderSales.ID_ORDER_SALES,
      "p_id_cliente_gift_card": this.itemOrderSales.ID_CLIENTE,
      "p_id_contact_gift_card": this.itemOrderSales.ID_CONTACT,
      "p_isfacturado" : "S"
    };
    this.giftCardTiendaService.UpdateOrderSalesTiendaFacturacion(params).subscribe(
      (response) => {
      },
      (error) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al crear el trace de la orden de compra' });
      }
    )
  }

  updateImageLiquidacion() {
    this.loading = true;
    let params = new FormData();
    params.append('p_id_order_gift_card', this.itemOrderSales.ID_ORDER_SALES);
    params.append('p_id_modelo_gift_card', this.itemOrderSales.ID_MODELO_GIFT_CARD);
    params.append('p_id_cliente_gift_card', this.itemOrderSales.ID_CLIENTE);
    params.append('p_id_contact_gift_card', this.itemOrderSales.ID_CONTACT);
    params.append('p_type_order_sales', this.giftCardTiendaService.TYPE_ORDER_SALES_TIENDA);
    params.append('p_type_file', this.fileService.FILE_LIQUI);
    params.append('p_creationuser', this.currentUser);
    params.append('file', this.fileLiquidacion.value[0]);
    this.fileService.CreateGiftCardOrderSalesTiendaFile(params).subscribe(
      (response) => {
        this.populateTableOrderSales();
        this.loading = false;
        this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Archivo de la orden de compra cargada correctamente.' });
      },
      (error) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al actualizar la liquidación.' });
      }
    )
  }

  updateImageConstancia() {
    this.loading = true;
    let params = new FormData();
    params.append('p_id_order_gift_card', this.itemOrderSales.ID_ORDER_SALES);
    params.append('p_id_modelo_gift_card', this.itemOrderSales.ID_MODELO_GIFT_CARD);
    params.append('p_id_cliente_gift_card', this.itemOrderSales.ID_CLIENTE);
    params.append('p_id_contact_gift_card', this.itemOrderSales.ID_CONTACT);
    params.append('p_type_order_sales', this.giftCardTiendaService.TYPE_ORDER_SALES_TIENDA);
    params.append('p_type_file', this.fileService.FILE_CONST);
    params.append('p_creationuser', this.currentUser);
    params.append('file', this.fileConstancia.value[0]);
    this.fileService.CreateGiftCardOrderSalesTiendaFile(params).subscribe(
      (response) => {
        this.populateTableOrderSales();
        this.loading = false;
        this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Archivo de la orden de compra cargada correctamente.' });
      },
      (error) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al actualizar la imagen de la orden de compra.' });
      }
    )
  }

  updateImageGuia() {
    this.loading = true;
    let params = new FormData();
    params.append('p_id_order_gift_card', this.itemOrderSales.ID_ORDER_SALES);
    params.append('p_id_modelo_gift_card', this.itemOrderSales.ID_MODELO_GIFT_CARD);
    params.append('p_id_cliente_gift_card', this.itemOrderSales.ID_CLIENTE);
    params.append('p_id_contact_gift_card', this.itemOrderSales.ID_CONTACT);
    params.append('p_type_order_sales', this.giftCardTiendaService.TYPE_ORDER_SALES_TIENDA);
    params.append('p_type_file', this.fileService.FILE_GUIAC);
    params.append('p_creationuser', this.currentUser);
    params.append('file', this.fileGuia.value[0]);
    this.fileService.CreateGiftCardOrderSalesTiendaFile(params).subscribe(
      (response) => {
        this.populateTableOrderSales();
        this.loading = false;
        this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Archivo de la orden de compra cargada correctamente.' });
      },
      (error) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al actualizar la imagen de la orden de compra.' });
      }
    )
  }

  onShowDlgOrderSales(order: GiftCardOrderSalesModel) {
    this.itemOrderSales = order;   
    this.disabledBtnDelete = false;
    this.observation.setValue('');
    this.observation.disable();
    this.dlgOrderSales = true;
  }

  onShowDlgOrderSalesFacturado(order: GiftCardOrderSalesModel){
    this.itemOrderSales = order;
    this.disabledBtnObservation = true;
    this.disabledBtnDelete = true;
    this.observation.setValue(order.OBSERVACIONES);
    this.observation.disable();
    this.dlgOrderSales = true;
  }

  downloadIMGModel() {
    saveAs(this.itemOrderSales.IMG_MODELO_GIFT_CARD, "modelo.jpg");
  }

  downloadIMGOrder() {
    saveAs(this.itemOrderSales.IMG_ORDEN_COMPRA, "orden.jpg");
  }

  downloadIMGCotizacion() {
    saveAs(this.itemOrderSales.IMG_COTIZACION, "cotizacion.jpg");
  }

  donwloadAdicional1() {
    saveAs(this.itemOrderSales.IMG_ADICIONAL1, "adicional.jpg");
  }

  donwloadAdicional2() {
    saveAs(this.itemOrderSales.IMG_ADICIONAL2, "adiciona2.jpg");
  }

  donwloadAdicional3() {
    saveAs(this.itemOrderSales.IMG_ADICIONAL3, "adiciona3.jpg");
  }

  donwloadLiquidacion() {
    saveAs(this.itemOrderSales.IMG_LIQUIDACION, "liquidacion.jpg");
  }

  donwloadConstancia() {
    saveAs(this.itemOrderSales.IMG_CONSTANCIA, "constanciajpg");
  }

  donwloadGuia() {
    saveAs(this.itemOrderSales.IMG_GUIA, "guia.jpg");
  }

  get imgLiquidacion() {
    return this.orderSalesFormGroup.get('imgLiquidacion');
  }

  get imgConstancia() {
    return this.orderSalesFormGroup.get('imgConstancia');
  }

  get imgGuia() {
    return this.orderSalesFormGroup.get('imgGuia');
  }

  get observation() {
    return this.orderSalesFormGroup.get('txtObservaciones');
  }

}